import type { IconProps } from './types';

export const DotsHandleIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path d="M3 16.5L3 14.5L5 14.5V16.5H3Z" fill={color} />
      <path d="M11 16.5V14.5H13V16.5H11Z" fill={color} />
      <path d="M19 16.5V14.5H21V16.5H19Z" fill={color} />
      <path d="M3 9.5L3 7.5L5 7.5V9.5H3Z" fill={color} />
      <path d="M11 9.5V7.5L13 7.5V9.5L11 9.5Z" fill={color} />
      <path d="M19 9.5V7.5L21 7.5V9.5H19Z" fill={color} />
      <path d="M3 16.5L3 14.5L5 14.5V16.5H3Z" stroke={color} strokeWidth="2" />
      <path d="M11 16.5V14.5H13V16.5H11Z" stroke={color} strokeWidth="2" />
      <path d="M19 16.5V14.5H21V16.5H19Z" stroke={color} strokeWidth="2" />
      <path d="M3 9.5L3 7.5L5 7.5V9.5H3Z" stroke={color} strokeWidth="2" />
      <path d="M11 9.5V7.5L13 7.5V9.5L11 9.5Z" stroke={color} strokeWidth="2" />
      <path d="M19 9.5V7.5L21 7.5V9.5H19Z" stroke={color} strokeWidth="2" />
    </svg>
  );
};
